// extracted by mini-css-extract-plugin
export default {"box":"box___IrPPx"};